/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_vegan': {
    width: 34,
    height: 32,
    viewBox: '0 0 34 32',
    data: '<path pid="0" d="M32.5 15.5c0 2.761-6.94 5-15.5 5-8.56 0-15.5-2.239-15.5-5m31 0c.167 5.333-2.7 16-15.5 16S1.333 20.833 1.5 15.5m31 0c0-1.532-2.136-2.903-5.5-3.82M1.5 15.5c0-1.005.919-1.94 2.5-2.724M8.5 6c2.5-2.5 4.6-4 9.5-.5 4.652 3.323 7 8.5 8.5 10-2.5 1.5-9.5 3.5-15 1S5.283 9.217 8.5 6zm0 0c-.666-.833-2-3.2-2-6m2 6C10 8 13 12.5 20 13.5"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_vegan.js